import "../Styles/WebAdmin.css"
import { getUserDetails, getsetStats } from "../Utility/AsyncStorageData";
import { greet } from './Navbar';
import { greetController } from "../WebAppComponents/ControllerNavbar"
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function Header(props) {

    // console.log("************Header************ ")
    var userDetails = getUserDetails();
    var stats = getsetStats() ?? {}


    const handleToogle = () => {
        if (props.show == 3) {
            greetController()
        }
        else {
            greet()
        }
        props.sendNavbarToParent ? props.sendNavbarToParent('close report') : console.log("")
    }


    return (
        <div className='Header' >
            <div className="menubars">
                <i class="fa-solid fa-bars" onClick={() => handleToogle()} ></i>
            </div>

            {
                props.show == 3 ? <></>
                    : <>
                        {/* <div className="logoimg">
                            <img src={flovation} alt="flovation_Logo" style={{width: "50px", marginTop:"0 10px"}} />
                        </div> */}
                        <div style={{ width: "90%", padding: "10px 0" }} className='com_name'>
                            {/* <h3>SuperManager</h3> */}
                            <h4 style={{ fontSize: 18 }}>{userDetails.comp_name}</h4>
                        </div>
                    </>
            }

            {props.show == 0 ?
                <div className="stats" /*style={{zIndex: 2}}*/ >
                    <h2 style={{ backgroundColor: "lightGreen", border: "2px solid green" }}
                        data-tooltip-id="my-tooltip1" data-tooltip-content="Full Load Machines"
                    >{stats.on_load ?? 0}</h2>
                    <h2 style={{ backgroundColor: "rgb(242, 187, 84)", border: "2px solid orange" }}
                        data-tooltip-id="my-tooltip1" data-tooltip-content="Free Load Machine"
                    >{stats.free_load ?? 0}</h2>
                    <h2 style={{ backgroundColor: "rgb(245, 143, 143)", border: "2px solid red" }}
                        data-tooltip-id="my-tooltip1" data-tooltip-content="Off Machine"
                    >{stats.zero_load ?? 0}</h2>
                    <h2 style={{ backgroundColor: "skyblue", border: "2px solid blue" }}
                        data-tooltip-id="my-tooltip1" data-tooltip-content="Disconnected Machine"
                    >{stats.disconnected_device ?? 0}</h2>
                    <Tooltip id="my-tooltip1" place="left"/>
                </div> : <></>}

            <div className='powered'>
                <i class="fa fa-copyright" style={{ fontSize: 10, paddingRight: 4 }}></i>
                <p>Powered by</p>
                <img style={{ width: "20px", margin: "0  0 0 5px" }}
                    src={require("../Assets/new_logo.png")}
                    alt="logo"
                />
                <p style={{ margin: 0, fontWeight: 600 }}>SuperManager</p>
            </div>
        </div>
    )
}

export default Header